import { FGTextInput } from "nsitools-react";
import * as React from "react";
import * as Yup from "yup";

import { DogPersonRelatedApi, PersonGridDto, SaveNewOwnerDto } from "../../../../../../api";
import { FGSRSHDateMaskInput, SmallFormGenerator } from "../../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";

export interface IDogOwnerSavePanelProps {
  onSaved: () => void;
  person: PersonGridDto;
  dogId: number;
  dogBirthDate: Date;
  dogOwnershipId: number;
}

export const DogOwnerSavePanel: React.FunctionComponent<IDogOwnerSavePanelProps> = ({
  onSaved,
  person,
  dogId,
  dogBirthDate,
  dogOwnershipId,
}) => {
  const { t } = useTl();
  const api = useApiService(DogPersonRelatedApi);

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      ownerFrom: Yup.date()
        .nullable()
        .required(t(ETLCodes.Required))
        .test("owner-date", t(ETLCodes.OwnerDateMustBeAfterDogBirthDate), async function (value) {
          return value >= dogBirthDate;
        }),
    });
  }, [dogBirthDate, t]);

  const save = React.useCallback(
    async (data: any) => {
      console.log("to save", data);
      data.dogId = dogId;
      var res = await api.saveNewOwner(data);
      onSaved();
      return res;
    },
    [api, dogId, onSaved]
  );

  const { data, loading, saving, saveItem } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: (id = dogOwnershipId) =>
          id
            ? api.getDogOwnership(id)
            : new SaveNewOwnerDto({
                dogId: dogId,
                personId: +person?.personId,
                personName: person?.computedName,
              }),
        saveApiFn: save,
      }),
      [api, dogId, dogOwnershipId, person, save]
    ),
    [dogOwnershipId]
  );

  return (
    <SmallFormGenerator
      onSubmit={saveItem}
      initialValues={data}
      loading={loading}
      editMode={true}
      validationSchema={FormSchema}
      saving={saving}
    >
      <FGTextInput name="personName" label={t(ETLCodes.OwnerSelected)} readonly />
      <FGSRSHDateMaskInput name="ownerFrom" label={t(ETLCodes.OwnerFrom)} />
      <FGSRSHDateMaskInput name="ownerTo" label={t(ETLCodes.OwnerTo)} />
    </SmallFormGenerator>
  );
};
